import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import QuillTextEditor from '../../../app/components/QuillTextEditor';
import { CreateUpdateTooltipDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface TooltipEditorFormProps {
  tooltipKey?: string;
  description?: string;
  tooltip: CreateUpdateTooltipDto;
  propertyChange: (obj: Partial<CreateUpdateTooltipDto>) => void;
}

export const TooltipEditorForm: React.FC<TooltipEditorFormProps> = props => {
  const { t, tk } = useTranslation('administrationLng');

  return (
    <Form className="d-grid gap-3">
      <FormRow controlId="key" label={t(tk.tooltips.tooltipKey)}>
        <Form.Control
          type="text"
          value={props.tooltipKey ?? ''}
          readOnly
          disabled
        />
      </FormRow>
      <FormRow
        controlId="description"
        label={t(tk.tooltips.tooltipDescription)}
      >
        <Form.Control
          as="textarea"
          rows={2}
          value={props.description ?? ''}
          readOnly
          disabled
        />
      </FormRow>
      <FormRow controlId="plText" label={t(tk.tooltips.tooltipPlText)}>
        <QuillTextEditor
          value={props.tooltip.plText}
          onChange={val => props.propertyChange({ plText: val ?? '' })}
          uniqueKey="plText"
          withoutSize
        />
      </FormRow>
      <FormRow controlId="enText" label={t(tk.tooltips.tooltipEnText)}>
        <QuillTextEditor
          value={props.tooltip.enText}
          onChange={val => props.propertyChange({ enText: val ?? '' })}
          uniqueKey="enText"
          withoutSize
        />
      </FormRow>
    </Form>
  );
};
